/** CSV yalnız sunucudan gelen string tutarlarla üretilir; istemci hesap yapmaz. */
export function downloadCsv(name: string, header: string[], rows: string[][]) {
  const esc = (v: string) => (/[;"\n]/.test(v) ? `"${v.replace(/"/g, '""')}"` : v)
  const csv = '﻿' + [header, ...rows].map((r) => r.map(esc).join(';')).join('\n')
  const url = URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8' }))
  const a = document.createElement('a')
  a.href = url
  a.download = name
  a.click()
  URL.revokeObjectURL(url)
}
